module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst renderMode = ((storage || {}).request || {}).renderMode || ''\n// load different bundles according to loaded route\nconst routeConfig \t\t= ((storage.request || {}).route || {}).config || {}\nconst isShippingOrder\t= routeConfig.isShippingOrder || false\nconst isInvoice\t\t\t= routeConfig.isInvoice || false\nconst isOffer\t\t\t= routeConfig.isOffer || false\nconst isCreditNote\t\t= routeConfig.isCreditNote || false\n// define page title for pdf-saas\nlet title = '';\nmodel.meta = model.meta || {}\nconst document = (((storage.request || {}).documentData || {}).meta || {}).document || {}\nif(isCreditNote && document.canceledNumber) {\ntitle = document.canceledNumber\n} else if(document.number){\ntitle = document.number\n}\nif(!title){\ntitle = model.meta.title || model.name || model.nameSEO || storage.__(\"error:unknownPageTitle\")\n}\nmodel.meta.title = title\nconst bodyClasses = []\nif(model.bodyClass) \t\t\t\tbodyClasses.push(model.bodyClass);\nif(environment.style) \t\t\t\tbodyClasses.push(environment.style);\nif((environment.device || {}).type) bodyClasses.push(`device-${environment.device.type}`);\nif(environment.breakPoint) \t\t\tbodyClasses.push(`breakPoint-${environment.breakPoint}`);\nif(isShippingOrder)\tbodyClasses.push('isShippingOrder');\nif(isInvoice)\t\tbodyClasses.push('isInvoice');\nif(isOffer)\t\t\tbodyClasses.push('isOffer');\nif(isCreditNote)\tbodyClasses.push('isCreditNote');\n%><html lang=\"<%= model.lang %>\">\n<head>\n<!-- meta tags -->\n<title><%= title %></title>\n<meta name=\"HandheldFriendly\" content=\"True\">\n<meta name=\"MobileOptimized\" content=\"360\"/>\n<meta name=\"viewport\" content=\"user-scalable=no,initial-scale=1.0, minimum-scale=1.0,maximum-scale=1.0\">\n<% utils.forEach(model.meta, function(metaContent, metaName){ %>\n<meta name=\"<%= metaName %>\" content=\"<%= metaContent %>\" />\n<% }); %>\n<!-- favicons -->\n<link rel=\"apple-touch-icon\" sizes=\"57x57\" href=\"/favicon/apple-icon-57x57.png\">\n<link rel=\"apple-touch-icon\" sizes=\"60x60\" href=\"/favicon/apple-icon-60x60.png\">\n<link rel=\"apple-touch-icon\" sizes=\"72x72\" href=\"/favicon/apple-icon-72x72.png\">\n<link rel=\"apple-touch-icon\" sizes=\"76x76\" href=\"/favicon/apple-icon-76x76.png\">\n<link rel=\"apple-touch-icon\" sizes=\"114x114\" href=\"/favicon/apple-icon-114x114.png\">\n<link rel=\"apple-touch-icon\" sizes=\"120x120\" href=\"/favicon/apple-icon-120x120.png\">\n<link rel=\"apple-touch-icon\" sizes=\"144x144\" href=\"/favicon/apple-icon-144x144.png\">\n<link rel=\"apple-touch-icon\" sizes=\"152x152\" href=\"/favicon/apple-icon-152x152.png\">\n<link rel=\"apple-touch-icon\" sizes=\"180x180\" href=\"/favicon/apple-icon-180x180.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"192x192\"  href=\"/favicon/android-icon-192x192.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"32x32\" href=\"/favicon/favicon-32x32.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"96x96\" href=\"/favicon/favicon-96x96.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"16x16\" href=\"/favicon/favicon-16x16.png\">\n<link rel=\"manifest\" href=\"/favicon/manifest.json\">\n<meta name=\"msapplication-TileColor\" content=\"#ffffff\">\n<meta name=\"msapplication-TileImage\" content=\"/favicon/ms-icon-144x144.png\">\n<meta name=\"theme-color\" content=\"#ffffff\">\n<!-- css sources -->\n<%\n// renderMode === html => get html for the corresponding pdf file.\n// the pdf creator does not use stylesheets via link\nif(renderMode === 'html'){\n%>\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appDocumentPDF.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<%\n} else {\n%>\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~app~appContractors~appCrew~appCustomers~appRegistration.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~style.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/style.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appCrew.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<%\n}\n%>\n</head>\n<body class=\"<%- bodyClasses.join(' ') %>\">\n<!-- sections -->\n<div class=\"appContainer\">\n<% if(document.number){ %>\n<%- helpers.renderSection('status'); %>\n<%- helpers.renderSection('main'); %>\n<% } else { %>\n<h1><%= storage.__('error:404.document-not-found') %></h1>\n<% } %>\n</div>\n<%\n// renderMode === html => get html for the corresponding pdf file.\nif(renderMode !== 'html'){\n%>\n<!-- js server sources -->\n<script type=\"application/javascript\" class=\"dynamicJSSources\">\nglobalThis.route \t\t\t\t= \"<%= model.route || '' %>\";\nglobalThis.tree \t\t\t\t= <%- model.tree || 'null' %>;\nglobalThis.globalActionsByScope = <%- model.globalActionsByScope || 'null' %>;\nglobalThis.updateClientStorage \t= <%- model.updateClientStorage || 'null' %>;\nglobalThis.routeParams \t\t\t= <%- model.routeParams || {} %>;\n</script>\n<!-- js sources -->\n<script type=\"text/javascript\" src=\"/webpack/js/vendors~app~appContractors~appCrew~appCustomers~appRegistration.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/appDocumentPDF.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/appCrew.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<%\n}\n%>\n</body>\n</html>"
  , __filename = "components/layouts/document.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const renderMode = ((storage || {}).request || {}).renderMode || ''
// load different bundles according to loaded route
const routeConfig 		= ((storage.request || {}).route || {}).config || {}
const isShippingOrder	= routeConfig.isShippingOrder || false
const isInvoice			= routeConfig.isInvoice || false
const isOffer			= routeConfig.isOffer || false
const isCreditNote		= routeConfig.isCreditNote || false
// define page title for pdf-saas
let title = '';
model.meta = model.meta || {}
const document = (((storage.request || {}).documentData || {}).meta || {}).document || {}
if(isCreditNote && document.canceledNumber) {
title = document.canceledNumber
} else if(document.number){
title = document.number
}
if(!title){
title = model.meta.title || model.name || model.nameSEO || storage.__("error:unknownPageTitle")
}
model.meta.title = title
const bodyClasses = []
if(model.bodyClass) 				bodyClasses.push(model.bodyClass);
if(environment.style) 				bodyClasses.push(environment.style);
if((environment.device || {}).type) bodyClasses.push(`device-${environment.device.type}`);
if(environment.breakPoint) 			bodyClasses.push(`breakPoint-${environment.breakPoint}`);
if(isShippingOrder)	bodyClasses.push('isShippingOrder');
if(isInvoice)		bodyClasses.push('isInvoice');
if(isOffer)			bodyClasses.push('isOffer');
if(isCreditNote)	bodyClasses.push('isCreditNote');

    ; __line = 31
    ; __append("<html lang=\"")
    ; __append(escapeFn( model.lang ))
    ; __append("\">\n<head>\n<!-- meta tags -->\n<title>")
    ; __line = 34
    ; __append(escapeFn( title ))
    ; __append("</title>\n<meta name=\"HandheldFriendly\" content=\"True\">\n<meta name=\"MobileOptimized\" content=\"360\"/>\n<meta name=\"viewport\" content=\"user-scalable=no,initial-scale=1.0, minimum-scale=1.0,maximum-scale=1.0\">\n")
    ; __line = 38
    ;  utils.forEach(model.meta, function(metaContent, metaName){ 
    ; __append("\n<meta name=\"")
    ; __line = 39
    ; __append(escapeFn( metaName ))
    ; __append("\" content=\"")
    ; __append(escapeFn( metaContent ))
    ; __append("\" />\n")
    ; __line = 40
    ;  }); 
    ; __append("\n<!-- favicons -->\n<link rel=\"apple-touch-icon\" sizes=\"57x57\" href=\"/favicon/apple-icon-57x57.png\">\n<link rel=\"apple-touch-icon\" sizes=\"60x60\" href=\"/favicon/apple-icon-60x60.png\">\n<link rel=\"apple-touch-icon\" sizes=\"72x72\" href=\"/favicon/apple-icon-72x72.png\">\n<link rel=\"apple-touch-icon\" sizes=\"76x76\" href=\"/favicon/apple-icon-76x76.png\">\n<link rel=\"apple-touch-icon\" sizes=\"114x114\" href=\"/favicon/apple-icon-114x114.png\">\n<link rel=\"apple-touch-icon\" sizes=\"120x120\" href=\"/favicon/apple-icon-120x120.png\">\n<link rel=\"apple-touch-icon\" sizes=\"144x144\" href=\"/favicon/apple-icon-144x144.png\">\n<link rel=\"apple-touch-icon\" sizes=\"152x152\" href=\"/favicon/apple-icon-152x152.png\">\n<link rel=\"apple-touch-icon\" sizes=\"180x180\" href=\"/favicon/apple-icon-180x180.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"192x192\"  href=\"/favicon/android-icon-192x192.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"32x32\" href=\"/favicon/favicon-32x32.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"96x96\" href=\"/favicon/favicon-96x96.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"16x16\" href=\"/favicon/favicon-16x16.png\">\n<link rel=\"manifest\" href=\"/favicon/manifest.json\">\n<meta name=\"msapplication-TileColor\" content=\"#ffffff\">\n<meta name=\"msapplication-TileImage\" content=\"/favicon/ms-icon-144x144.png\">\n<meta name=\"theme-color\" content=\"#ffffff\">\n<!-- css sources -->\n")
    ; __line = 60
    ; 
// renderMode === html => get html for the corresponding pdf file.
// the pdf creator does not use stylesheets via link
if(renderMode === 'html'){

    ; __line = 64
    ; __append("\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appDocumentPDF.css?usTS=")
    ; __line = 65
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n")
    ; __line = 66
    ; 
} else {

    ; __line = 68
    ; __append("\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~app~appContractors~appCrew~appCustomers~appRegistration.css?usTS=")
    ; __line = 69
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~style.css?usTS=")
    ; __line = 70
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/style.css?usTS=")
    ; __line = 71
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appCrew.css?usTS=")
    ; __line = 72
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n")
    ; __line = 73
    ; 
}

    ; __line = 75
    ; __append("\n</head>\n<body class=\"")
    ; __line = 77
    ; __append( bodyClasses.join(' ') )
    ; __append("\">\n<!-- sections -->\n<div class=\"appContainer\">\n")
    ; __line = 80
    ;  if(document.number){ 
    ; __append("\n")
    ; __line = 81
    ; __append( helpers.renderSection('status') )
    ; __append("\n")
    ; __line = 82
    ; __append( helpers.renderSection('main') )
    ; __append("\n")
    ; __line = 83
    ;  } else { 
    ; __append("\n<h1>")
    ; __line = 84
    ; __append(escapeFn( storage.__('error:404.document-not-found') ))
    ; __append("</h1>\n")
    ; __line = 85
    ;  } 
    ; __append("\n</div>\n")
    ; __line = 87
    ; 
// renderMode === html => get html for the corresponding pdf file.
if(renderMode !== 'html'){

    ; __line = 90
    ; __append("\n<!-- js server sources -->\n<script type=\"application/javascript\" class=\"dynamicJSSources\">\nglobalThis.route 				= \"")
    ; __line = 93
    ; __append(escapeFn( model.route || '' ))
    ; __append("\";\nglobalThis.tree 				= ")
    ; __line = 94
    ; __append( model.tree || 'null' )
    ; __append(";\nglobalThis.globalActionsByScope = ")
    ; __line = 95
    ; __append( model.globalActionsByScope || 'null' )
    ; __append(";\nglobalThis.updateClientStorage 	= ")
    ; __line = 96
    ; __append( model.updateClientStorage || 'null' )
    ; __append(";\nglobalThis.routeParams 			= ")
    ; __line = 97
    ; __append( model.routeParams || {} )
    ; __append(";\n</script>\n<!-- js sources -->\n<script type=\"text/javascript\" src=\"/webpack/js/vendors~app~appContractors~appCrew~appCustomers~appRegistration.js?usTS=")
    ; __line = 100
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/appDocumentPDF.js?usTS=")
    ; __line = 101
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/appCrew.js?usTS=")
    ; __line = 102
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n")
    ; __line = 103
    ; 
}

    ; __line = 105
    ; __append("\n</body>\n</html>")
    ; __line = 107
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/layouts/document.ejs

}